import { OrgMembersTab } from "./OrgMembersTab";

export function ClientOrgTab() {
  return (
    <OrgMembersTab
      kind="client"
      title="Client"
      subtitle={(orgName) => `Manage Better Auth permissions for ${orgName}`}
      showCustomerColumns
      emptyMessage="No members found. Add a member to get started."
    />
  );
}

export default ClientOrgTab;
